import { Anchor, Stack, Text, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

/** Placeholder screens; each is replaced by its roadmap item (1.19–1.22). */

function Soon({ title }: { title: string }) {
  const { t } = useTranslation();
  return (
    <Stack gap="xs">
      <Title order={2}>{title}</Title>
      <Text c="dimmed">{t("common.comingSoon")}</Text>
    </Stack>
  );
}

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Stack gap="xs">
      <Title order={2}>{t("common.notFound")}</Title>
      <Anchor component={Link} to="/">
        {t("common.backHome")}
      </Anchor>
    </Stack>
  );
}
